import { Grid, Switch } from "@mui/material";
import React, { ChangeEvent } from "react";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { TaskTypeClassTextAlign } from "ui/Scripts/source/models/enums";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";

interface IFormDesignerComponentPropertiesTextAlignmentProps {
    formFieldMargin: string;
    taskTypeCol?: ITaskTypeCol;
    onChange?: (id: string, name: string, value: string | boolean) => void;
}

export const FormDesignerComponentPropertiesTextAlignment = (
    props: IFormDesignerComponentPropertiesTextAlignmentProps
) => {
    //NOTE: class name may be used in other style class as prefix or suffix => need to use padding (problem: sText <=> sTextArea)
    const classes = " " + (props.taskTypeCol?.class ?? "") + " ";

    const removeAllignmentClasses = () => {
        let updatedClasses = classes;
        [TaskTypeClassTextAlign.Right, TaskTypeClassTextAlign.Center].forEach((alignClass) => {
            updatedClasses = updatedClasses.replace(" " + alignClass + " ", " ");
        });
        return updatedClasses.trim();
    };

    const handleSwitchChange = (
        _event: ChangeEvent<HTMLInputElement>,
        checked: boolean,
        className: string
    ) => {
        props.onChange(
            props.taskTypeCol?.field,
            "class",
            removeAllignmentClasses() +
                (checked ? " " + className : "")
        );
    };

    return (
        <>
            <Grid item sm={6}>
                <FormField title={Translations.FormTextAlignmentRight} margin={props.formFieldMargin}>
                    <Switch
                        name="textAlignRight"
                        checked={classes.includes(" " + TaskTypeClassTextAlign.Right + " ")}
                        onChange={(event, checked) => handleSwitchChange(event, checked, TaskTypeClassTextAlign.Right)}
                    />
                </FormField>
            </Grid>
            <Grid item sm={6}>
                <FormField title={Translations.FormTextAlignmentCenter} margin={props.formFieldMargin}>
                    <Switch
                        name="textAlignCenter"
                        checked={classes.includes(" " + TaskTypeClassTextAlign.Center + " ")}
                        onChange={(event, checked) => handleSwitchChange(event, checked, TaskTypeClassTextAlign.Center)}
                    />
                </FormField>
            </Grid>
        </>
    );
};
